/**
 * File search-modal.js
 *
 * Handles the search modal functionality with accordion-like toggle behavior.
 * Toggles modal open/close when search button is clicked.
 */

(function () {
  const searchModal = document.getElementById('search-modal');
  const searchModalOverlay = document.getElementById('search-modal-overlay');
  const searchOpener = document.querySelector('.search-opener');
  const searchModalInput = document.querySelector('.search-modal-input');

  if (!searchModal || !searchModalOverlay || !searchOpener) {
    return;
  }

//Toggle Search Modal 
  function toggleSearchModal(e) {
    e.preventDefault();
    if (searchModal.classList.contains('active')) {
      closeSearchModal();
    } else {
      openSearchModal();
    }
  }


 //Open the search modal
  function openSearchModal() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
      '--scrollbar-width',
      scrollbarWidth + 'px'
    );

    document.documentElement.classList.add('modal-open');
    searchModal.classList.add('active');
    searchModalOverlay.classList.add('active');
    // Focus on the input field for better UX
    setTimeout(() => {
      if (searchModalInput) {
        searchModalInput.focus();
      }
    }, 100);
  }

 
  //  Close the search modal
  function closeSearchModal() {
    document.documentElement.classList.remove('modal-open');
    searchModal.classList.remove('active');
    searchModalOverlay.classList.remove('active');
  }

// Clear the search input field

  function clearSearchInput() {
    if (searchModalInput) {
      searchModalInput.value = '';
      searchModalInput.focus();
    }
  }

//  Handle keydown events
  function handleKeyDown(e) {
    if (e.key === 'Escape') {
      closeSearchModal();
    }
  }

  // Validate the search form
  function validateSearchForm(e) {
    if (!searchModalInput || searchModalInput.value.trim() === '') {
      e.preventDefault();
      return false;
    }
    return true;
  }
// Event listeners for the search modal
  const clearBtn = document.querySelector('.clear-btn');
  const modalCloseBtn = document.querySelector('.modal-close');
  const searchForm = document.querySelector('.search-modal-form') || searchModalInput?.form;

  // Event listeners
  searchOpener.addEventListener('click', toggleSearchModal);
  searchModalOverlay.addEventListener('click', closeSearchModal);
  document.addEventListener('keydown', handleKeyDown);
  
  // Form submit validation listener
  if (searchForm) {
    searchForm.addEventListener('submit', validateSearchForm);
  }
  
  // Clear button listener
  if (clearBtn) {
    clearBtn.addEventListener('click', clearSearchInput);
  }
  
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeSearchModal);
  }
})();
